import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../softCosts/softCosts.css";
import "./weighted-score.css";
import ReactTooltip from "react-tooltip";
import actions from "../../actions";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const WeightedScore = ({ isAssetView = false }) => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const { getSurveyAssetById } = useSelector(state => state.assetSurveyProjectReducer);
    const { getDataByIdResponse, assetDynamicFields } = useSelector(state => state.assetReducer);

    const [scoreData, setScoreData] = useState([]);

    useEffect(() => {
        if (isAssetView) {
            dispatch(actions.getSurveyAssetById(id));
        }
    }, [isAssetView]);

    useEffect(() => {
        const config = assetDynamicFields?.asset_custom_field ?? {};
        const values = getDataByIdResponse?.dynamic_fields;

        if (!config || !values) return;

        const bandOrder = Object.keys(config || {});

        const merged = bandOrder?.flatMap(group => {
            const groupFields = config?.[group] || [];

            return (groupFields ?? [])
                ?.filter(field => field?.field_mode === "weighted_selection")
                ?.map(field => {
                    const valueObj = values?.[field?.field_name] || {};
                    return {
                        ...field,
                        score: valueObj?.score ?? null,
                        value: valueObj?.value ?? null,
                        weighted_score: valueObj?.weighted_score ?? null
                    };
                })
                .sort((a, b) => (a?.index ?? 0) - (b?.index ?? 0));
        });

        setScoreData(merged);
    }, [assetDynamicFields, getDataByIdResponse]);

    useEffect(() => {
        const asset = getSurveyAssetById?.data?.asset;
        const dynamicFields = asset?.asset_dynamic_fields;
        const bandOrder = asset?.dynamic_band;

        if (dynamicFields && bandOrder && !isAssetView) {
            const filtered = Object.values(dynamicFields || {})
                ?.filter(item => item.field_mode === "weighted_selection")
                ?.sort((a, b) => {
                    const orderA = bandOrder?.[a?.group_field];
                    const orderB = bandOrder?.[b?.group_field];
                    if (orderA !== undefined && orderB !== undefined && orderA !== orderB) {
                        return orderA - orderB;
                    }
                    if (a?.group_field === b?.group_field) {
                        return (a?.index ?? 0) - (b?.index ?? 0);
                    }

                    return 0;
                });

            setScoreData(filtered);
        }
    }, [getSurveyAssetById]);

    const total = scoreData?.reduce((sum, item) => sum + (Number(item?.weighted_score) || 0), 0);
    const totalWeightedScore = Math.round(total * 100) / 100;
    const totalWeighted = scoreData?.reduce((sum, item) => sum + (Number(item?.rules?.weight) || 0), 0);
    const totalWeightedPercentage = Math.round(totalWeighted * 100) / 100;

    return (
        <div className="tab-active location-sec image-sec tab-grey efci-otr fund-efci pb-0 weighted-score-table">
            <div className={`dtl-sec col-md-12 mt-0`}>
                <ReactTooltip
                    id="projectCost"
                    className="rc-tooltip-custom-class"
                    backgroundColor="#007bff"
                    place="left"
                    effect="solid"
                    delayShow={500}
                />

                <div className="custom-table-scroll">
                    <div className="table-section table-plan table-scroll build-fci fc-capital-nw build-efci proj-soft-cost">
                        <table className="table table-common-outer">
                            <tbody>
                                <tr>
                                    <td>
                                        <table className="table table-common table-froze-soft">
                                            <thead>
                                                <tr className="table-head-title table-row-sf">
                                                    <th className="img-sq-box">
                                                        <img src="/img/sq-box.png" alt="" />
                                                    </th>
                                                    <th className="build-add title-soft">Category</th>
                                                    <th className="ass-attr-th">Assessment Attribute</th>
                                                    <th className="ass-attr-th">Assessment Method</th>{" "}
                                                    <th className="score-crit-th">Scoring Criteria</th>
                                                    <th className="sel-score-th">Selected Score</th>
                                                    <th className="weight-th">Weight(%)</th>
                                                    <th className="we-score-th">Weighted Score</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {(scoreData ?? [])?.length > 0 ? (
                                                    (scoreData ?? [])?.map((item, index) => (
                                                        <tr className="blue-bg-row">
                                                            <td className="img-sq-box">
                                                                <img src="/img/sq-box.png" alt="" />
                                                            </td>
                                                            <td className="build-add title-soft category-title">{item.group_field || "-"}</td>
                                                            <td className="set-value">{item.label || "-"}</td>
                                                            <td className="set-value">{item.name || "-"}</td>
                                                            <td className="set-value">
                                                                {(item.field_options ?? [])?.map(opt => `${opt.value}.`).join("\n") || "-"}
                                                            </td>
                                                            <td className="set-value score-cent">{item.score ?? "-"}</td>
                                                            <td className="set-value score-cent">
                                                                {item?.rules?.weight ? `${item?.rules?.weight}%` : "-"}
                                                            </td>
                                                            <td className="build-add set-value score-cent">{item.weighted_score ?? "-"}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={8} className="text-center no-weight-data">
                                                            No records found
                                                        </td>
                                                    </tr>
                                                )}
                                                {(scoreData ?? [])?.length > 0 ? (
                                                    <tr className="blue-tot-bg-row">
                                                        <td className="img-sq-box">
                                                            <img src="/img/sq-box.png" alt="" />
                                                        </td>
                                                        <td className="build-add tot-weight-th">Total</td>
                                                        <td className="tot-weight-sc"></td>
                                                        <td className="tot-weight-sc"></td>
                                                        <td className="tot-weight-sc"></td>
                                                        <td className="tot-weight-sc"></td>
                                                        <td className="tot-weight-sc score-cent">{totalWeightedPercentage}%</td>
                                                        <td className="tot-weight-sc score-cent">{totalWeightedScore}</td>
                                                    </tr>
                                                ) : null}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WeightedScore;
